import { defineStore } from 'pinia';
import { reactive, toRefs } from 'vue';
import { cloneDeep } from 'lodash-es';
import {
  setLocalStorageItem,
  getLocalStorageItem,
  STORAGE_KEYS,
  removeLocalStorageItem,
} from '@/utils/localStorage';

export interface MainStoreState {
  isAppLoading: boolean;
  teamTwrn: string | null;
  orgTwrn: string | null;
  previousTeamTwrn: string | null;
  isMavenChatOpen: boolean;
}

export const useMainStore = defineStore('main', () => {
  const DEFAULT_STATE = {
    toasts: [],
    isAppLoading: false,
    teamTwrn: getLocalStorageItem<string>(STORAGE_KEYS.TEAM_TWRN),
    orgTwrn: getLocalStorageItem<string>(STORAGE_KEYS.ORG),
    previousTeamTwrn: null,
    isMavenChatOpen: false,
  };

  const state = reactive<MainStoreState>(cloneDeep(DEFAULT_STATE));

  const abortControllers = reactive<Record<string, AbortController>>({});

  const setTeamTwrn = (teamTwrn: string | null) => {
    state.previousTeamTwrn = state.teamTwrn;
    state.teamTwrn = teamTwrn;
    setLocalStorageItem<string | null>(STORAGE_KEYS.TEAM_TWRN, teamTwrn);
  };

  const unsetTeamTwrn = () => {
    state.teamTwrn = null;
    removeLocalStorageItem(STORAGE_KEYS.TEAM_TWRN);
  };

  const setOrgTwrn = (orgTwrn: string) => {
    state.orgTwrn = orgTwrn;
    setLocalStorageItem<string>(STORAGE_KEYS.ORG, orgTwrn);
  };

  const setPreviousTeamTwrn = (teamTwrn: string | null) => {
    state.previousTeamTwrn = teamTwrn;
  };

  const unsetOrgTwrn = () => {
    state.orgTwrn = null;
    removeLocalStorageItem(STORAGE_KEYS.ORG);
  };

  function toggleMavenChat() {
    state.isMavenChatOpen = !state.isMavenChatOpen;
  }


  const $reset = () => {
    Object.assign(state, cloneDeep(DEFAULT_STATE));
  };

  return {
    ...toRefs(state),
    setTeamTwrn,
    unsetTeamTwrn,
    setPreviousTeamTwrn,
    setOrgTwrn,
    unsetOrgTwrn,
    toggleMavenChat,
    abortControllers,
    $reset,
  };
});
